"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharterIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const get_icon_name_1 = require("./get-icon-name");
const SIZES = {
    sm: 20,
    md: 30,
    lg: 45,
    xl: 60,
};
const getSize = (size) => (typeof (size) === 'number' ? size : SIZES[size]);
let SVG_ICON_PATH;
/**
 * Renders an amenity, diving, or toy icon.
 *
 * **Must** be initialised with the path to the SVG file.
 *
 * @example ```tsx
 * import svgUrl from '@charterindex/icons/dist/icons.svg'
 *
 * CharterIcon.init(svgUrl);
 *
 * <CharterIcon iconName="AIR_CONDITIONING"/>
 * ```
 */
exports.CharterIcon = (({ className, iconName, size = 'md' }) => {
    const px = getSize(size);
    return ((0, jsx_runtime_1.jsx)("svg", { className: className, width: px, height: px, fill: "currentColor", "aria-hidden": true, children: (0, jsx_runtime_1.jsx)("use", { href: SVG_ICON_PATH + '#' + (0, get_icon_name_1.getIconName)(iconName) }) }));
});
exports.CharterIcon.init = (svgIconPath) => SVG_ICON_PATH = svgIconPath; // eslint-disable-line @typescript-eslint/no-explicit-any
exports.CharterIcon.displayName = 'CharterIcon'; // eslint-disable-line @typescript-eslint/no-explicit-any
//# sourceMappingURL=charter-icon.js.map